// Décision pure du raccourci clavier do/undo, isolée (aucun import) pour rester
// testable sans tirer la chaîne UI. Cmd/Ctrl+Z = undo, +Shift = redo.
export const matchUndoRedoKey = (e) => {
  if (!(e.metaKey || e.ctrlKey) || e.altKey) return null;
  if (e.key !== 'z' && e.key !== 'Z') return null;
  return e.shiftKey ? 'redo' : 'undo';
};
